import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenNib } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModule, Text,
} from '@domain-group/suit-theme'

import formatDate from '@functions/formatDate'
import { buildItemTitle } from '@functions/orderItem'

import type { OrderItemModel } from '@models/types'

interface OrderItemDetailsModuleProps {
  loading: boolean,
  orderItem: OrderItemModel | {},
}

const OrderItemDetailsModule = (props: OrderItemDetailsModuleProps) => {
  const { loading, orderItem } = props

  // @ts-expect-error TS7022
  const dueDate = orderItem?.dates?.due?.date
    // @ts-expect-error TS2448
    ? `Due on ${formatDate(dueDate, 'dd/MM/yyyy', 'DD')}` : ''
  // @ts-expect-error TS2339
  const requiredDate = orderItem?.dates?.required?.date
    // @ts-expect-error TS2339
    ? `Required by ${formatDate(orderItem?.dates?.required?.date, 'dd/MM/yyyy', 'DD')}`
    : ''

  return (
    <DashboardModule
      loading={loading}
      title="Order Item Details"
    >
      {!loading && (
        <Box justifyContent="flex-start" padding="large" alignItems="center">
          <Box
            alignItems="center"
            backgroundColor="#f8f8f8"
            borderRadius={5}
            flexShrink={0}
            height="36px"
            justifyContent="center"
            marginRight="medium"
            width="36px"
          >
            <FontAwesomeIcon icon={faPenNib} />
          </Box>

          <Box justifyContent="space-between" width="calc(100% - 42px)">
            <Box flexDirection="column" justifyContent="center" maxWidth="calc(100% - 80px)" marginRight="medium">
              <Text fontSize="small" color="bodyFontColor" marginBottom="small" variant="ellipsis">
                {buildItemTitle({ orderableItem: orderItem }!)}
              </Text>

              <Text color="bodyFontLightColor" fontSize="xsmall">
                {dueDate || requiredDate}
              </Text>
            </Box>

            <Box
              flexDirection="column"
              alignItems="flex-end"
              justifyContent="center"
              maxWidth="30%"
            >
              {/*
               // @ts-expect-error TS2339 */}
              {orderItem?.id && (
                <Text fontSize="small" marginBottom="xsmall">
                  {/*
                   // @ts-expect-error TS2339 */}
                  #{orderItem?.id}
                </Text>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </DashboardModule>
  )
}

export default OrderItemDetailsModule
